import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewPostPageNew from "../../components/Post/ViewPostPageNew";



const ViewPostPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Pending Post" link2="/post" title="View Post" />

        {/* AddUserLayer */}
        <ViewPostPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewPostPage;
